import React from 'react'
import { Carousel } from 'primereact/carousel'
import EmptyLink from '@aytm/app/swidget/base/components/EmptyLink.tsx'
import { IEcommerceQuestionViewProps } from '@aytm/app/swidget/base/questions/Ecommerce/types.ts'
import useViewport from '@aytm/app/swidget/base/modules/viewport/useViewport.ts'
import style from './Header.module.scss'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'

interface IHeaderProps {
  containerTop: number
  schema: IEcommerceQuestionViewProps['schema']
  findability: boolean
  totals: number[]
  onMainPage: boolean
  onCartPage: boolean
  onCartOpen: () => void
  onHomeClick: () => void
  clearSelection: () => void
}

const Header = ({
  containerTop,
  schema,
  findability,
  totals,
  onMainPage,
  onCartPage,
  onCartOpen,
  onHomeClick,
  clearSelection
}: IHeaderProps) => {
  const viewport = useViewport()
  const { t } = useSurveyLocale()
  return (
    <>
      {viewport.mobile ? (
        <>
          <header className={style.headerMobile}>
            <button className={style.backIcon} onClick={onHomeClick} />
            <div
              className={style.condition}
              dangerouslySetInnerHTML={{ __html: `${schema.search_condition || ''}` }}
              onClick={clearSelection}
            />
            <EmptyLink color="#111">
              <div className={style.filterIcon} />
            </EmptyLink>
            <EmptyLink color="#111">
              <div className={style.searchIcon} />
            </EmptyLink>
          </header>
        </>
      ) : (
        <header className={style.header}>
          <div className={style.top}>
            <div className={style.topInner}>
              <div className={style.logos}>
                <EmptyLink color="#111">
                  <div className={style.jordan} />
                </EmptyLink>
                <EmptyLink color="#111">
                  <div className={style.converse} />
                </EmptyLink>
              </div>
              <div className={style.links}>
                <EmptyLink color="#111">
                  <div className={style.topText}>{t('questions', 'ec', 'nike', 'findStore')}</div>
                </EmptyLink>
                <div className={style.line}>|</div>
                <EmptyLink color="#111">
                  <div className={style.topText}>{t('questions', 'ec', 'nike', 'help')}</div>
                </EmptyLink>
                <div className={style.line}>|</div>
                <EmptyLink color="#111">
                  <div className={style.topText}>{t('questions', 'ec', 'nike', 'joinUs')}</div>
                </EmptyLink>
                <div className={style.line}>|</div>
                <EmptyLink color="#111">
                  <div className={style.topText}>{t('questions', 'ec', 'nike', 'signIn')}</div>
                </EmptyLink>
              </div>
            </div>
          </div>
          <div
            className={`${style.middle} ${containerTop > 40 && !onCartPage && !onMainPage ? style.middleFixed : ''}`}
          >
            <div className={style.middleInner}>
              <div className={style.logoContainer}>
                <div className={style.logo} onClick={onHomeClick} />
              </div>
              <div className={style.filters}>
                <EmptyLink color="#111">
                  <div className={style.filterItem}>{t('questions', 'ec', 'nike', 'new')}</div>
                </EmptyLink>
                <EmptyLink color="#111">
                  <div className={style.filterItem}>{t('questions', 'ec', 'nike', 'men')}</div>
                </EmptyLink>
                <EmptyLink color="#111">
                  <div className={style.filterItem}>{t('questions', 'ec', 'nike', 'women')}</div>
                </EmptyLink>
                <EmptyLink color="#111">
                  <div className={style.filterItem}>{t('questions', 'ec', 'nike', 'kids')}</div>
                </EmptyLink>
                <EmptyLink color="#111">
                  <div className={style.filterItem}>{t('questions', 'ec', 'nike', 'jordan')}</div>
                </EmptyLink>
                <EmptyLink color="#111">
                  <div className={style.filterItem}>{t('questions', 'ec', 'nike', 'sports')}</div>
                </EmptyLink>
              </div>
              <div className={style.search}>
                <div className={style.input}>
                  <EmptyLink color="#111">
                    <div className={style.searchIcon} />
                  </EmptyLink>
                  <div
                    className={style.condition}
                    dangerouslySetInnerHTML={{ __html: `${schema.search_condition || ''}` }}
                    onClick={clearSelection}
                  />
                </div>
                <EmptyLink color="#111">
                  <div className={style.headerButton}>
                    <div className={style.heartIcon} />
                  </div>
                </EmptyLink>
                {findability ? (
                  <EmptyLink color="#111">
                    <div className={style.headerButton}>
                      <div className={style.cartIcon} />
                    </div>
                  </EmptyLink>
                ) : (
                  <div className={style.cart} onClick={onCartOpen}>
                    <div className={style.amount}>{totals[0] > 99 ? '99+' : totals[0]}</div>
                    <div className={style.cartIcon} />
                  </div>
                )}
              </div>
            </div>
          </div>
          {!onCartPage && (
            <div className={style.swiper}>
              <div className={style.carousel}>
                <div className={style.carouselLayout}>
                  <EmptyLink color="#111">
                    <span className={style.layoutContent}>&nbsp;</span>
                  </EmptyLink>
                </div>
                <Carousel
                  value={[
                    t('questions', 'ec', 'nike', 'item1'),
                    t('questions', 'ec', 'nike', 'item2'),
                    t('questions', 'ec', 'nike', 'item3')
                  ]}
                  circular={true}
                  showIndicators={false}
                  numVisible={1}
                  numScroll={1}
                  itemTemplate={item => <div className={style.carouselItem}>{item}</div>}
                />
              </div>
            </div>
          )}
          {onMainPage && (
            <div className={style.backWrapper}>
              <button className={style.back} onClick={onHomeClick}>
                <div className={style.backIcon} />
                <span>{t('questions', 'ec', 'nike', 'back')}</span>
              </button>
            </div>
          )}
        </header>
      )}
    </>
  )
}
export default Header
